/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { VendorListModel } from './vendor-list.model';
import { BlacklistItemValidityDtoModel } from './blacklist-item-validity-dto-model';

export class VendorBlacklistItemDtoModel {
    uuid: string | null = null;
    owner: string | null = null;
    vendorListViewVO: VendorListModel | null = null;
    blacklistItemValidityDTO: BlacklistItemValidityDtoModel | null = null;
}
